import { render } from "./AdditionsPage.vue?vue&type=template&id=1345ef82&scoped=true"
import script from "./AdditionsPage.vue?vue&type=script&lang=js"
export * from "./AdditionsPage.vue?vue&type=script&lang=js"

import "./AdditionsPage.vue?vue&type=style&index=0&id=1345ef82&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1345ef82"]])

export default __exports__